module.exports = __webpack_public_path__ + "img/RiskOfOverLimit.5584699f.svg";